export enum WindowStorageToken {
    managerApiToken = 'apiToken',
    partnerUserApiToken = 'partnerPanelApiToken',
    vendorUserApiToken = 'vendorPanelApiToken',
}

export enum WindowStorageUser {
    manager = 'manager',
    vendorUser = 'vendorPanelUser',
    partnerUser = 'partnerPanelUser',
}

export class WindowStorage implements Storage {
    clear(): void {
        return window.localStorage.clear();
    }

    key(index: number): string | null {
        return window.localStorage.key(index);
    }

    removeItem(key: string): void {
        return window.localStorage.removeItem(key);
    }

    getItem(key: string): string | null {
        return window.localStorage.getItem(key);
    }

    setItem(key: string, value: string): void {
        return window.localStorage.setItem(key, value);
    }

    readonly length: number = window.localStorage.length;
}

export const windowStorage = new WindowStorage();
